import axios from 'axios'
import setConfig from '@/config/axios-config'
setConfig(axios)

// const basePath = '/MarkServer/json/mark'
const basePath = '/PJService/action'
const pjServerPath = 'PJServer/action'
const studentServerPath = '/CandidateServer'
const pjUnitPath = 'PJService/action/pjunit'
const toolPath = 'kwTool/pj'
const axiosConfig = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
}

/**
 * 查询扫描监控总览信息
 * @author wangk 2018-05-01T16:38:47+0800
 * @param  {Object} params [description]
 * @return {[type]}        [description]
 */
const queryMarkProgressSummary = (params = {}) => {
  return axios.post(basePath + '/queryMarkProgressSummary', params)
    .then(res => res.data)
}

/**
 * 查询当前机构每一题的评卷进度总览信息
 * @author wangk 2018-04-28T11:12:02+0800
 * @param  {Object} params [description]
 * @return {[type]}        [description]
 */
const queryMarkProgressByItems = (params = {}) => {
  return axios.post(basePath + '/queryMarkProgressByItems', params)
    .then(res => res.data)
}

/**
 * 按机构的评卷监控信息
 * @author wangk 2018-05-01T17:42:27+0800
 * @param  {Object} params [description]
 * @return {[type]}        [description]
 */
const queryMarkProgressByOrgs = (params = {}) => {
  return axios.post(basePath + '/queryMarkProgressByOrgs', params)
    .then(res => res.data)
}

/**
 * 查询评卷进度详情(指定机构)
 * @author wangk 2018-05-03T10:44:51+0800
 * @param  {Object} params [description]
 * @return {[type]}        [description]
 */
const queryMarkProgressDetails = (params = {}) => {
  return axios.post(basePath + '/queryMarkProgressDetails', params)
    .then(res => {
      // 修改教师评卷量数据类型
      for (let teacher of res.data.data[0].teachers) {
        teacher.markDoneCnt = parseFloat(teacher.markDoneCnt)
        teacher.markTodoCnt = parseFloat(teacher.markTodoCnt)
      }
      // 修改学校评卷量数据类型
      for (let subOrg of res.data.data[0].subOrgs) {
        subOrg.progress = parseFloat(subOrg.progress)
        subOrg.markTotalCnt = parseFloat(subOrg.markTotalCnt)
        subOrg.markDoneCnt = parseFloat(subOrg.markDoneCnt)
        subOrg.markTodoCnt = parseFloat(subOrg.markTodoCnt)
        subOrg.arbitrationPaperCnt = parseFloat(subOrg.arbitrationPaperCnt)
        subOrg.problemPaperCnt = parseFloat(subOrg.problemPaperCnt)
        subOrg.avgScoreIncludeZero = parseFloat(subOrg.avgScoreIncludeZero)
        subOrg.onlineCnt = parseFloat(subOrg.onlineCnt)
      }
      return res.data
    })
}

/**
 * 查询当前机构下的学校评卷进度详情
 * @author wangk 2018-08-14T16:19:09+0800
 * @param  {Object} params [description]
 * @return {[type]}        [description]
 */
const querySchoolsMarkProgress = (params = {}) => {
  return axios.post(basePath + '/querySchoolsMarkProgress', params)
    .then(res => {
      for (let subOrg of res.data.data) {
        subOrg.progress = parseFloat(subOrg.progress)
        subOrg.markTotalCnt = parseFloat(subOrg.markTotalCnt)
        subOrg.markDoneCnt = parseFloat(subOrg.markDoneCnt)
        subOrg.markTodoCnt = parseFloat(subOrg.markTodoCnt)
        subOrg.arbitrationPaperCnt = parseFloat(subOrg.arbitrationPaperCnt)
        subOrg.problemPaperCnt = parseFloat(subOrg.problemPaperCnt)
        subOrg.avgScoreIncludeZero = parseFloat(subOrg.avgScoreIncludeZero)
        subOrg.onlineCnt = parseFloat(subOrg.onlineCnt)
      }
      return res.data
    })
}

/**
 * 任务回收
 * @author wangk 2018-05-23T10:28:30+0800
 * @param  {Object} params { examId: '', subjectId: '', orgId: '', divId: '', userId: '', teacherIds: [] }
 * @return {[type]}        [description]
 */
const releaseTask = (params = {}) => {
  return axios.post(basePath + '/recallTask', params)
    .then(res => res.data)
}

/**
 * 任务恢复
 * @author chenxb 2024-04-30T16:28:30+0800
 * @param  {Object} params { examId: '', subjectId: '', divId: '', teacherPhone: '' }
 * @return {[type]}        [description]
 */
const restoreTask = (params = {}) => {
  let data = params.data
  return axios.post(pjUnitPath + `/restoreTask?examId=${data.examId}&subjectId=${data.subjectId}&divId=${data.divId}&teacherPhone=${data.teacherPhone}`, data)
    .then(res => res.data)
}
/**
 * 无效量计算
 * @author chenxb 2024-11-11T10:28:30+0800
 * @param  {Object} params { examId: '', subjectId: '' }
 * @return {[type]}        [description]
 */
const calInvalidAmount = (data = {}) => {
  return axios.post(pjUnitPath + `/calInvalidAmount?examId=${data.examId}&subjectId=${data.subjectId}`, data)
    .then(res => res.data)
}
/**
 * 生成任务
 * @author chenxb 2024-11-12T14:58:28+0800
 * @param  {Object} params { examId: '', subjectId: '' }
 * @return {[type]}        [description]
 */
const initMission = (data = {}) => {
  return axios.post(`/PJService/action/pjexam/${data.examId}/${data.subjectId}/createPjTask.jsp?json=`)
    .then(res => res.data)
}
/**
 * 重置评卷接口状态
 * @author chenxb 2026-07-06T16:29:34+0800
 * @param  {Object} params { examId: '', subjectId: '' }
 * @return {[type]}        [description]
 */
const resetInterfaceByPj = (data = {}) => {
  return axios.post(`/scan/resetInterfaceByPj?examId=${data.examId}&subjectId=${data.subjectId}`)
    .then(res => res.data)
}
/**
 * 转为问题卷
 * @author chenxb 2025-05-07T14:31:31+0800
 * @param  {Object} params { examId: '', subjectId: '' }
 * @return {[type]}        [description]
 */
const switchToQuestionPaper = (data = {}) => {
  return axios.post(`/PJService/action/pjunit/${data.examId}/${data.subjectId}/${data.divId}/transToQuestionTask`)
    .then(res => res.data)
}

/**
 * 超总量任务恢复
 * @author chenxb 2024-07-08T17:28:30+0800
 * @param  {Object} params { examId: '', subjectId: '', divId: '', teacherPhone: '' }
 * @return {[type]}        [description]
 */
const recoverProgress = (params = {}) => {
  let data = params.data
  return axios.post(`/PJService/action/pjexam/${data.examId}/${data.subjectId}/${data.divId}/recoverProgress`)
    .then(res => res.data)
}

/**
 * 扫描引擎地址
 * @author wangk 2018-05-23T19:53:34+0800
 * @param  {Object} params {"examId":"1526901068834","subjectId":"1525924488508"}
 * @return Promise
 */
const assignScanEngine = (params = {}) => {
  let json = JSON.stringify(params)
  return axios.post(`${pjServerPath}/assignScanEngine.jsp`, `app=assignScanEngine&flag=assignScanEngine&json=${json}`, axiosConfig)
    .then(res => res.data)
}

/**
 * 获取
 * @author wangk 2018-05-24T17:06:16+0800
 * @param  {Object} params [description]
 * @return {[type]}        [description]
 */
const getCandiCnt = (params = {}) => {
  let json = JSON.stringify(params)
  return axios.post('/CandidateServer/candidate.jsp', `app=getCandiCnt&flag=candiCnt&json=${json}`, axiosConfig)
    .then(res => res.data)
}

/**
 * 查询快速结束评卷状态
 * @author wangk 2018-06-11T10:13:40+0800
 * @param  {Object} params { examId: '', subjectId: '' }
 * @return {Promise}
 *         data  {
 *                 result: 'true',
 *                 // opened(已开启快速结束评卷), closed(还没有开启快速结束评卷)
 *                 data: { status: 'opened/closed' }
 *               }
 */
const requestQuickEndMarkStatus = (params = {}) => {
  return axios.post(basePath + '/requestQuickEndMarkStatus', params)
    .then(res => res.data)
}

/**
 * 快速结束评卷
 * @author wangk 2018-06-11T10:20:02+0800
 * @param  {Object} params { examId: '', subjectId: '', mobilePhone: '', checkCode: '' }
 * @return {Promise}
 *         data  {
 *                 result: 'true',
 *                 // opened(已开启快速结束评卷), closed(还没有开启快速结束评卷)
 *                 data: { status: 'opened/closed' }
 *               }
 */
const requestQuickEndMark = (params = {}) => {
  return axios.post(basePath + '/requestQuickEndMark', params, {
    timeout: 5 * 60 * 1000
  }).then(res => res.data)
}
/**
 * 通过密号查询准考证号或通过准考证号查询密号
 * @author chenxb 2020-08-03T17:06:16+0800
 * @param  {Object} params [description]
 * @return {[type]}        [description]
 */
const getSecretNum = (params = {}) => {
  return axios.post(basePath + '/candidate/queryIdOrEncode', params)
    .then(res => res.data)
}

/**
 * 评卷量与扫描量检查
 * @author chenxb 2020-08-03T17:06:16+0800
 * @param  {
  'data': {
        'examId': '',
        'subjectId': '',
        'orgId': '', //发起机构
      }
    } params [description]
 * @return {
    'data': [{
    'markCount': 111,
    'scanItemCount': 111  //相等则检查通过
      }]
    }        [description]
 */
const queryMarkCount = (params = {}) => {
  return axios.post(basePath + '/queryMarkCount', params)
    .then(res => res.data)
}

/**
 * 选考组合缺失考生统计
 * @author changh 2022-03-08T17:06:16+0800
 * @param  {
  'data': {
    'examId': '',
    'searchStudentCondition': '', 查询条件，支持考号/姓名
    'searchSubjectCondition': [{
      symbol:'', 表达式支持：>,<,<=,>=,=
      num:'' 科目数
    }],
    pageSize:10,
    pageNum:111
  } params [description]
 * @return {
  }        [description]
*/
const countStudentSubjectInfo = (params = {}) => {
  return axios.post(studentServerPath + '/countStudentSubjectInfo', params)
    .then(res => res.data)
}
/**
 * 选考组合缺失考生信息查询
 * @author changh 2022-03-08T17:06:16+0800
 * @param  {
  'data': {
    'examId': '',
    'searchStudentCondition': '', 查询条件，支持考号/姓名
    'searchSubjectCondition': [{
      symbol:'', 表达式支持：>,<,<=,>=,=
      num:'' 科目数
    }],
    pageSize:10,
    pageNum:111
  } params [description]
 * @return {
  }        [description]
*/
const getStudentSubjectInfo = (params = {}) => {
  return axios.post(studentServerPath + '/getStudentSubjectInfo', params)
    .then(res => res.data)
}

/**
 * 更新考生学选科目组合信息
 * @author changh 2022-03-08T17:06:16+0800
 * @param  {
  'data': {
    'examId': '',
    'studentId': '', 考生ID
    'subjects': [{
      subjectId:'', 科目ID
      subjectName:'' 科目名称
    }]
  } params [description]
 * @return {
  }        [description]
*/
const updateStudentSubjectInfo = (params = {}) => {
  return axios.post(studentServerPath + '/updateStudentSubjectInfo', params)
    .then(res => res.data)
}

/**
 * 导出轨迹
 * @author chenxb 2024-06-04T09:28:30+0800
 * @param  {Object} params { examId: '', subjectId: '', divId: '', studentNos: '' }
 * @return {[type]}        [description]
 */
const getTaskLogs = (params = {}) => {
  let data = params.data
  return axios.post(toolPath + `/getGradeLog`, data)
    .then(res => res.data)
}
/**
 * 导出问题卷密号
 * @author chenxb 2025-04-29T10:40:56+0800
 * @param  {Object} params { examId: '', subjectId: '', divId: '' }
 * @return {[type]}        [description]
 */
const exportQuestionTask = (params = {}) => {
  let data = params.data
  return axios.post(`/PJService/action/pjexam/exportQuestionTask?examId=${data.examId}&subjectId=${data.subjectId}&divId=${data.divId}`, data)
    .then(res => res.data)
}

/**
 * 导出教师评卷信息
 * @author chenxb 2024-07-04T016:43:32+0800
 * @param  {Object} params { examId: '', subjectId: '',}
 * @return {[type]}        [description]
 */
const getTeacherLogs = (params = {}) => {
  let data = params.data
  return axios.post(toolPath + `/exportTeacherInfo?examId=${data.examId}${data.subjectId ? `&subjectId=${data.subjectId}` : ''}`, data)
    .then(res => res.data)
}

/**
 * 获取教师信息
 * @author chenxb 2025-11-18T011:07:32+0800
 * @param  {Object} params { examId: '', subjectId: '',"candidateIds: [], state: 3, type: 1}
 * @return {[type]}        [description]
 */
const getGradeLogEx = (params = {}) => {
  let data = params.data
  return axios.post(toolPath + `/getGradeLogEx`, data)
    .then(res => res.data)
}

/**
 * 导出教师评卷信息
 * @author chenxb 2024-10-17T016:43:32+0800
 * @param  {Object} params { examId: '', subjectId: '',orgId: ''}
 * @return {[type]}        [description]
 */
const setNoObjectItemOmrFinish = (params = {}) => {
  let data = params.data
  return axios.post(`/PJService/action/pjexam/${data.examId}/${data.subjectId}/${data.orgId}/setNoObjectItemOmrFinish`)
    .then(res => res.data)
}

export {
  queryMarkProgressSummary,
  queryMarkProgressByItems,
  queryMarkProgressByOrgs,
  queryMarkProgressDetails,
  querySchoolsMarkProgress,
  releaseTask,
  restoreTask,
  calInvalidAmount,
  initMission,
  resetInterfaceByPj,
  switchToQuestionPaper,
  recoverProgress,
  assignScanEngine,
  getCandiCnt,
  requestQuickEndMarkStatus,
  requestQuickEndMark,
  getSecretNum,
  queryMarkCount,
  getStudentSubjectInfo,
  updateStudentSubjectInfo,
  countStudentSubjectInfo,
  getTaskLogs,
  exportQuestionTask,
  getTeacherLogs,
  getGradeLogEx,
  setNoObjectItemOmrFinish
}



// WEBPACK FOOTER //
// ./src/model/monitor-mark-model.js